module.exports = __webpack_public_path__ + "static/media/rouletteTicking_1.21455d3d.mp3";